import { Store } from '../../store/store.model';
import { createSelector } from 'reselect';

export const selectUsers = (state: Store) => state.users.data;
export const selectUser = (userId: string) =>
  createSelector(selectUsers, (users) => users?.find((user) => user.UserID === userId));
